import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    templateUrl: './ordersFilters-modal.html',
    standalone: false
})
export class OrdersFilterModalComponent {

  requestNumber: string;

  constructor(
    public dialogRef: MatDialogRef<OrdersFilterModalComponent>, @Inject(MAT_DIALOG_DATA) data: any) {
    if (data && data.product) {
      this.requestNumber = data.requestNumber;
    }
  }

}
